import React, { useContext, useEffect, useRef, useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../Context/ConfigContext';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import "react-multi-carousel/lib/styles.css";
import 'react-tabs/style/react-tabs.css';
import slugify from 'slugify';
import PartImages from './PartImages';
import OESection from './OESection';
import { AddToRecent } from '../../../Helper/RecentCart';
import Reviews from './Reviews';
import CompatibilityCars from './CompatibilityCars';
import { AddToCartNotifier } from '../../../Components/CartComponents';
import { Helmet } from 'react-helmet';
import CarInfoBox from '../../Cars/CarInfoBox';
import { OverlayLoader, Spinner } from '../../../Components/Shimmers';
import SimilarParts from './SimilarParts';
import { CartsContext } from '../../../Context/CartsContext';
import NewArrivals from '../../Account/NewArrivals';
import RedeemOfferSlider from '../../Home/RedeemOfferSlider';
import DeliveryDaysComponent from './DeliveryDaysComponent';
import SimilarCharacteristics from './SimilarCharacteristics';
import GetPaymentMethods from './GetPaymentMethods';
import RecentViews from '../../Home/RecentViews';
import { UseRewardsPoints } from '../../../Components/GlobalFunctions';
import { axiosGet } from '../../../Apis/axiosMethods';
import { default_image } from '../../../Imgaes';
import Config from '../../../appConfig';

const PartDetails = () => {
  const { t } = useTranslation();
  const locale = localStorage.getItem('lang');
  const dir = localStorage.getItem('dir');

  const {
    gdcURL,
    apiURL,
    business_delivery_days,
    currency,
    isUserInternational,
    setIsCartDropdownOpen,
    apiB2BURL,
    token,
    FavItems,
    business_type,
    business_id
  } = useContext(ConfigContext);

  const {
    AddToCart,
    GetCartItemQty,
    AddToFavorite,
    RemoveToFavorite,
    GetStockPolicyItem
  } = useContext(CartsContext);

  const { part_slug } = useParams();
  const parts = part_slug.split("-");

  const SUP_ID = parts[parts.length - 1];
  const ART_NUMBER = parts[parts.length - 2];

  const [loading, setLoading] = useState(true);
  const [InvalidCarMatchWithPart, setInvalidCarMatchWithPart] = useState(localStorage.getItem('car_info') ? true : false);
  const [InvalidCarMatchWithPartLoading, setInvalidCarMatchWithPartLoading] = useState(true);

  const [partInfo, setpartInfo] = useState();
  const [reviewsData, setReviewsData] = useState([]);

  const [addToCartLoading, setAddToCartLoading] = useState(false);

  const [isAssignLoading, setIsAssignLoading] = useState(true);
  const [isAssignBrand, setIsAssignBrand] = useState(null);

  const isAddingRef = useRef(false);


  const car_info = localStorage.getItem('car_info') ? JSON.parse(localStorage.getItem('car_info')) : [];
  const [selectQty, setSelectedQty] = useState(1);
  const location = useLocation();

  const [isFavouriteUpdate, setIsFavouriteUpdate] = useState(false);

  const [price, setPrice] = useState(0);
  const [priceLoading, setPriceLoading] = useState(false);
  const [priceDisplay, setPriceDisplay] = useState('...');
  const [thumbnail, setThumbnail] = useState(null);

  const [qty, setQTY] = useState(0);
  const [specLimit, setSpecLimit] = useState(10);
  const [isFavorite, setIsFavorite] = useState(false);

  const [isSticky, setSticky] = useState(false);
  const [PTINTL, setPTINTL] = useState(0);

  const part = partInfo && partInfo[0];

  const [policyMinQty, setPolicyMinQty] = useState(1);

  useEffect(() => {
    const loadStockPolicy = async () => {
      if (!part) return;

      const stockPolicy = await GetStockPolicyItem(
        part?.ART_SEARCH_NUMBER,
        part?.stock_oe,
        part?.ART_SUP_ID || part?.stock_sup_id,
        part?.ART_SUP_BRAND || part?.stock_brand_name
      );

      const minQty = Number(stockPolicy?.policy_min_qty || 1);

      setPolicyMinQty(minQty);
      setSelectedQty(minQty);
    };

    loadStockPolicy();
  }, [part]);

  const incrementQty = async (part) => {
    const prev_qty = Number(await GetCartItemQty(part.ART_SEARCH_NUMBER));

    const stock = Number(part?.stock_available_qty);
    const step = Number(policyMinQty || 1);
    const currentQty = Number(selectQty);

    const nextQty = currentQty + step;

    // Full step available
    if (stock >= prev_qty + nextQty) {
      setSelectedQty(nextQty);
      return;
    }

    // Last remaining stock
    const remainingStock = stock - prev_qty;

    if (remainingStock > currentQty) {
      setSelectedQty(remainingStock); // Example: 26
      return;
    }

    toast.success(
      <AddToCartNotifier
        item_name={t("sorry_we_have_only", {
          value: stock,
        })}
      />
    );
  };

  const decrementQty = () => {
    const step = Number(policyMinQty || 1);
    const currentQty = Number(selectQty);

    // If current qty is not an exact multiple
    // Example: 26 -> 20
    if (currentQty % step !== 0) {
      setSelectedQty(Math.floor(currentQty / step) * step);
      return;
    }

    // Otherwise decrease normally
    setSelectedQty(Math.max(step, currentQty - step));
  };

  const handleAddToCart = async (part) => {

    if (isAddingRef.current) return;

    isAddingRef.current = true;
    setAddToCartLoading(true);

    try {

      const prev_qty = Number(await GetCartItemQty(part?.ART_SEARCH_NUMBER));

      const stock = Number(part?.stock_available_qty);
      const addQty = Number(selectQty);

      const partImg = thumbnail
        ? thumbnail
        : `${apiURL}/public/placeholder_category.jpeg`;

      if (stock >= prev_qty + addQty) {

        const url = window.location.href;

        await AddToCart(
          part,
          addQty,
          partImg,
          url
        );

        setIsCartDropdownOpen(true);
        window.scrollTo(0, 0);

      } else {

        toast.success(
          <AddToCartNotifier
            item_name={t("sorry_we_have_only", {
              value: stock,
            })}
            item_img={partImg}
          />
        );

      }

    } catch (error) {

      console.log(error);

    } finally {

      setAddToCartLoading(false);
      isAddingRef.current = false;

    }
  };

  useEffect(() => {
    checkCountry();
  }, [isUserInternational])

  const checkCountry = () => {
    if (isUserInternational && partInfo && partInfo[0]) {
      setPTINTL(partInfo[0].PT_INTL)
    } else {
      setPTINTL(1);
    }
  }

  useEffect(() => {
    GetPartInfo();
  }, [location, part_slug])


  const GetPartInfo = async () => {
    try {
      setLoading(true);

      const { data } = await axiosGet(`/Parts/GetPartInfo`, {
        business_id: localStorage.getItem('business_id'),
        art_number: ART_NUMBER,
        sup_id: SUP_ID,
        lang: localStorage.getItem('lang'),
        type: business_type,
        currency: currency
      });

      setpartInfo(data.data);

      if (data?.data?.length > 0) {
        const row = data.data[0];

        setReviewsData(data.reviews);
        setQTY(row.stock_available_qty);
        checkCountry();

        GetPrice(
          row.ART_SEARCH_NUMBER.replaceAll('-', '').replaceAll(' ', ''),
          row?.ART_SUP_ID
        );

        AddToRecent(
          row?.ART_ID,
          row?.ART_ARTICLE_NR,
          row?.ART_PRODUCT_NAME,
          row?.stock_brand_name,
          0,
          0,
          1,
          row?.MEDIA_SOURCE,
          window.location.href,
          SUP_ID,
          row?.stock_oe
        );
      }

      window.scrollTo(0, 0);
    } catch (error) {
      console.error("GetPartInfo error:", error);
    } finally {
      setLoading(false);
    }
  };

  const CheckBrands = async () => {
    try {
      const response = await axiosGet(`/Parts/CheckAssignBrandsForBusiness`,
        {
          business_sup_id: partInfo[0]?.ART_SUP_ID
        });

      if (response?.data?.success) {
        setIsAssignBrand(response?.data?.assigned)
      }

    } catch (error) {
      console.log(error);
    } finally { }
  }

  useEffect(() => {
    CheckBrands();
  }, [location, partInfo])


  const GetPrice = (part_number, sup_id) => {
    const business_id = localStorage.getItem("business_id");
    const business_user_id = localStorage.getItem("business_user_id");
    setPriceLoading(true);
    fetch(`${apiB2BURL}/Customer/Parts/${business_type === 1 ? "GetGaragePrice" : "GetPrice"}?number=${part_number}&vendor_id=1&lang=${locale ?? 'en'}&currency=${currency}&sup_id=${sup_id}`,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'token': token,
          'businessid': business_id,
          'businessuserid': business_user_id
        }
      })
      .then((res) => res.json())
      .then((response) => {

        setPrice(response.data.pricing.price);
        setPriceDisplay(response.data.pricing.price_display);

        setPriceLoading(false);

      })
  }

  const invalidPartMatch = (value) => {
    setInvalidCarMatchWithPart(value);
    setInvalidCarMatchWithPartLoading(false);
  }

  useEffect(() => {
    document.title = "Parts Details | Ghayar";
    if (!loading && partInfo && partInfo[0]) {
      const part = partInfo[0];
      document.title = `${part.ART_SUP_BRAND} ${part.ART_ARTICLE_NR} ${part.ART_PRODUCT_NAME} | Ghayar`;
    }
  }, [loading, partInfo]);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 200) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleRemoveToFavorite = async () => {
    try {
      await RemoveToFavorite(partInfo[0]);
      setIsFavorite(false)
    } catch (error) {
      console.error(error);
    }
  }

  const handleAddToFavorite = async () => {
    try {
      const partImg = thumbnail
        ? thumbnail
        : `${apiURL}/public/placeholder_category.jpeg`;

      const url = window.location.href;

      const data = {
        business_id,
        item_id: partInfo[0]?.ART_ID,
        item_number: partInfo[0]?.ART_ARTICLE_NR.replace(/[^a-zA-Z0-9]/g, ''),
        item_title: partInfo[0]?.PRODUCT_GROUP_EN,
        item_sup_id: partInfo[0]?.stock_sup_id,
        item_mrp: partInfo[0]?.stock_price_mrp,
        item_price: Number(business_type) === 1 ? partInfo[0]?.stock_bg_price : partInfo[0]?.stock_bb_price,
        item_qty: 1,
        item_img_url: partImg,
        item_url: url,
        max_qty: partInfo[0]?.stock_available_qty,
        item_store_id: partInfo[0]?.inventory_store_id,
        item_stock_oe: partInfo[0]?.stock_oe,
        item_delivery_days: partInfo[0]?.stock_delivery_days,
        item_brand_name: partInfo[0]?.stock_brand_name
      };

      await AddToFavorite(data);
      setIsFavouriteUpdate(prev => !prev);
    } catch (error) {
      console.log("Error adding to favorites:", error);
      toast.error(t("Error adding to favorites."));
    }
  };

  useEffect(() => {
    if (FavItems && partInfo?.length > 0) {

      const foundItem = FavItems.find(
        item =>
          item.item_number?.replaceAll(/\s/g, '') ===
          partInfo[0]?.ART_SEARCH_NUMBER?.replaceAll(/\s/g, '') &&
          item?.item_brand_name === partInfo[0]?.stock_brand_name
      );

      setIsFavorite(!!foundItem);
    }
  }, [FavItems, isFavouriteUpdate, partInfo]);

  const GetWarrantyImage = (warranty) => {
    switch (warranty) {
      case '1 Year':
        return '1year.gif';
      case '6 Months':
        return '6month.gif';
      case '3 Years':
        return '3_years_warranty.png';
      default:
        return '1_year_warranty.png';
    }
  };


  const beforePrice = partInfo && Number(
    business_type === 1
      ? partInfo[0]?.stock_before_bg_price
      : partInfo[0]?.stock_before_bb_price
  );

  const isOutOfStock = !partInfo || !partInfo[0] || Number(partInfo[0].stock_available_qty) <= 0;

  return (
    <>
      {loading ? (
        <div style={{ height: "70vh" }}>
          <OverlayLoader />
        </div>
      )
        :
        <main className="main" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
          <Helmet>
            <title>
              {loading
                ? "Parts Details | Ghayar"
                : partInfo && partInfo[0]
                  ? `${partInfo[0].ART_SUP_BRAND} ${partInfo[0].ART_SEARCH_NUMBER} ${partInfo[0].ART_PRODUCT_NAME} | Ghayar`
                  : "Parts Details | Ghayar"
              }
            </title>
            <meta name="keywords" content={partInfo && partInfo[0] ? `${partInfo[0].ART_SUP_BRAND}, ${partInfo[0].ART_SEARCH_NUMBER}, ${partInfo[0].ART_PRODUCT_NAME}, Ghayar` : "spare parts, auto parts, Ghayar"} />
          </Helmet>

          {partInfo && partInfo.length === 0 &&
            <div className="container text-center" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' }}>
              <p> <i className='fas fa-exclamation-circle' style={{ fontSize: '134px', color: '#cc010c' }}></i> <br /> <br /> <br /> <br />
                <strong>This part is currently unavailable</strong> but the good news is that we are already working on restocking it as quickly as possible. In the meantime, our team would be happy to assist you with alternatives or provide updates on availability so you can plan with confidence. We truly appreciate your patience and are excited to make this part available to you again very soon!
              </p>
            </div>
          }

          {partInfo && partInfo.length > 0 &&
            <div className="container">

              <nav aria-label="breadcrumb" className="breadcrumb-nav">
                <ol className="breadcrumb" dir={dir}>
                  <li className="breadcrumb-item">
                    <NavLink to={'/'}>
                      <i className="icon-home" />
                    </NavLink>
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to={`/Spare-Parts/Catelog`}>{t("catelog")}</NavLink>
                  </li>
                  {partInfo ? (
                    <li className="breadcrumb-item">
                      <NavLink to={`/Spare-Parts/${slugify(`${partInfo[0].ART_PRODUCT_NAME}`.toLowerCase())}`}>
                        {partInfo[0].ART_PRODUCT_NAME}{" "}
                      </NavLink>
                    </li>
                  ) : (
                    <li className="breadcrumb-item">
                      <NavLink to={() => { }}>...</NavLink>
                    </li>
                  )}
                </ol>


              </nav>
              <CarInfoBox />
              <>
                {partInfo && InvalidCarMatchWithPartLoading === false && localStorage.getItem('car_info') && car_info && car_info[0] &&
                  <div>
                    {loading === false && InvalidCarMatchWithPart ?
                      <div className='pl-5 pr-5 pt-5 pb-3' style={{ backgroundColor: 'rgb(254, 245, 245)' }}>
                        <div style={{ color: 'rgb(226, 10, 24)' }}><i className="fas fa-times-circle"></i> {t('this_part_not_fits_your')}</div>
                        <div style={{ color: 'rgb(254, 245, 245)' }}><h3 style={{ fontWeight: 400 }}> {car_info && car_info[0] && car_info[0].TYPEL}</h3></div>
                      </div>
                      :
                      <div className='pl-5 pr-5 pt-5 pb-3' style={{ backgroundColor: 'rgb(245, 254, 247)' }}>
                        <div style={{ color: '#009e7e' }}><i className="fas fa-check-circle"></i> {t('this_part_fits_your')}</div>
                        <div style={{ color: '#009e7e' }}><h3 style={{ fontWeight: 400 }}> {car_info && car_info[0] && car_info[0].TYPEL}</h3></div>
                      </div>

                    }
                  </div>
                }

                <ToastContainer
                  position="bottom-right"
                  autoClose={5000}
                  hideProgressBar
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"

                />
                <div className="product-single-container product-single-default">
                  <div className="cart-message d-none">
                    <strong className="single-cart-notice">

                    </strong>
                    <span>has been added to your cart.</span>
                  </div>
                  <div>
                    {/* create box stick on scroll to top */}
                    <div style={isSticky ? {
                      position: 'fixed',
                      top: '0',
                      backgroundColor: '#FFF',
                      width: '100%',
                      left: '0',
                      zIndex: '1000',
                      padding: '10px 50px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      zIndex: 10000000
                    } : {}}>

                      {isSticky && <main className="main" dir={dir} style={{ textAlign: 'left' }}>
                        <div className="container">
                          <div className="row">
                            <div className="col-7" style={{
                              color: '#59666e',
                              fontFamily: 'Montserrat, Arial, sans-serif',
                              fontSize: '12px',
                              fontWeight: '500',
                              lineHeight: '2',
                              display: 'flex',
                              alignItems: 'center',
                              paddingRight: '3%'
                            }}>
                              <table>
                                <tr>
                                  <td rowSpan={2} style={{ width: '100px', textAlign: 'left' }}>
                                    {partInfo && <img style={{ height: '70px' }} height={70} src={thumbnail ? thumbnail : default_image} alt={partInfo && partInfo[0].ART_PRODUCT_NAME} />}
                                  </td>

                                  <td><div style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '18px', fontWeight: '500 !important', lineHeight: '0', color: '#000', height: '20px', width: '100%' }}>{partInfo && partInfo[0].ART_SUP_BRAND} {partInfo && partInfo[0].ART_ARTICLE_NR} {partInfo && partInfo[0].ART_PRODUCT_NAME}</div>
                                    <div style={{ color: '#59666e', fontSize: '12px', textAlign: 'left' }}>Part Number: {partInfo && partInfo[0].ART_ARTICLE_NR}</div>
                                  </td>
                                </tr>
                              </table>
                            </div>

                            <div className="col-3 pl-5">
                              {qty > 0 && price > 0 && partInfo && partInfo[0] && <div style={{ lineHeight: 0, display: 'inline-block', flexShrink: 0, fontSize: '15px', fontWeight: '500', marginRight: '8px', width: '100%', color: '#000' }}> {priceDisplay}</div>}
                              {qty > 0 && price > 0 && partInfo && partInfo[0] && <small className='mt-2'>Offer price excl. 5.0% VAT, Free delivery</small>}
                            </div>
                            <div className="col-1 p-3" onClick={() => {
                              if (isFavorite) {
                                handleRemoveToFavorite()
                              } else {
                                handleAddToFavorite()
                              }
                            }} style={{ cursor: "pointer", textAlign: 'right' }}>
                              <i onClick={() => isFavorite ? handleRemoveToFavorite() : handleAddToFavorite()} className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`} style={{ fontSize: '28px' }} ></i> <span style={{ fontSize: '14px', fontWeight: '500', paddingBottom: '2px' }}></span>
                            </div>
                            <div className='col-1'>
                              {price > 0 && partInfo && partInfo[0] &&
                                <button
                                  onClick={() => handleAddToCart(partInfo[0])}
                                  className="btn btn-dark add-cart mr-2 text-light "
                                  title={t('add_to_cart')}
                                  style={{ float: 'right' }}
                                  disabled={addToCartLoading || isAddingRef.current}
                                >
                                  {t('add_to_cart')}
                                </button>
                              }
                            </div>

                          </div> </div></main>
                      }

                    </div>

                    {/* <div className="row">
                      <div className='col-md-6 d-flex'>
                        <h3 className="product-title mb-2 mt-2" style={{ direction: dir === 'rtl' ? 'ltr' : '' }} >
                          {partInfo && partInfo[0].ART_SUP_BRAND} {""}
                          {partInfo && partInfo[0].ART_SEARCH_NUMBER} {""}
                          {partInfo && partInfo[0].ART_PRODUCT_NAME}
                        </h3>

                        {partInfo && partInfo[0]?.ART_SUP_ID === 475 &&
                          <img
                            src="/assets/images/gif/borge_beck.gif"
                            alt=""
                            style={{ width: "55px", marginLeft: "10px" }}
                          />
                        }

                        {partInfo && [358, 4595].includes(Number(partInfo[0]?.ART_SUP_ID)) &&
                          <img
                            src="/assets/images/gif/german_flag_gif.gif"
                            alt=""
                            style={{ width: "55px", marginLeft: "10px" }}
                          />
                        }
                      </div>

                      <div className="col-md-6 mt-2">
                        {policyMinQty > 1 && (
                          <div className='badge bg-info'>
                            <div>
                              <span style={{
                                color: '#BF360C',
                                fontSize: '14px',
                                fontWeight: '600'
                              }}>
                                This product can only be ordered in multiples of <strong style={{
                                  fontSize: '20px',
                                  color: '#D84315',
                                  background: '#FFE0B2',
                                  padding: '0 10px',
                                  borderRadius: '4px'
                                }}>{policyMinQty}</strong>
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div> */}


                    <div className="row">
                      <div className='col-md-6 d-flex align-items-center flex-wrap'>
                        <h3 className="product-title mb-2 mt-2" style={{ direction: dir === 'rtl' ? 'ltr' : '' }} >
                          {partInfo && partInfo[0].ART_SUP_BRAND} {""}
                          {partInfo && partInfo[0].ART_SEARCH_NUMBER} {""}
                          {partInfo && partInfo[0].ART_PRODUCT_NAME}
                        </h3>

                        {partInfo && partInfo[0]?.ART_SUP_ID === 475 &&
                          <img
                            src="/assets/images/banners/british_flag.gif"
                            alt=""
                            style={{ width: "55px", marginLeft: "10px" }}
                          />
                        }

                        {partInfo && [358, 4595].includes(Number(partInfo[0]?.ART_SUP_ID)) &&
                          <img
                            src="/assets/images/banners/german_flag.gif"
                            alt=""
                            style={{ width: "55px", marginLeft: "10px" }}
                          />
                        }
                      </div>

                      <div className="col-md-6 mt-2 d-flex justify-content-start align-items-center">
                        {policyMinQty > 1 && (
                          <div style={{
                            backgroundColor: '#E3F2FD',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: '1px solid #64B5F6',
                            borderLeft: '5px solid #1976D2',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            maxWidth: '100%'
                          }}>
                            <i className="fas fa-info-circle" style={{ color: '#1976D2', fontSize: '18px' }}></i>
                            <span style={{
                              color: '#0D47A1',
                              fontSize: '13px',
                              fontWeight: '500',
                              whiteSpace: 'nowrap'
                            }}>
                              This product can only be ordered in multiples of <strong
                                style={{
                                  fontSize: '18px',
                                  color: '#1565C0',
                                  borderRadius: '4px'
                                }}>{policyMinQty}</strong>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='col-md-12 mt-1' style={{ display: loading ? 'none' : 'flex' }}>
                      <div className="ratings-container">
                        {partInfo && <span className="mt-1 ml2 mr-2">{t('article_number', { value: partInfo[0].ART_ARTICLE_NR })} | </span>}


                        {/* End .product-ratings */}
                        <NavLink to={() => { }} className="rating-link" onClick={(e) => {
                          e.preventDefault();
                          const reviewsSection = document.getElementById('reviews-section');
                          if (reviewsSection) {
                            reviewsSection.scrollIntoView({ behavior: 'smooth' });
                          }
                        }}>

                          {partInfo && partInfo[0].ART_AVG_RATING && partInfo[0].ART_AVG_RATING !== 0 ?
                            '★'.repeat(Math.round(partInfo[0].ART_AVG_RATING)) + '☆'.repeat(5 - Math.round(partInfo[0].ART_AVG_RATING))
                            : '☆☆☆☆☆'
                          }
                          ( {partInfo && partInfo[0].TOTAL_REVIEWS && partInfo[0].TOTAL_REVIEWS !== 0 ? partInfo[0].TOTAL_REVIEWS : 0} {t('reviews')} )
                        </NavLink>
                        {/* End .product-ratings */}
                      </div>
                    </div>
                  </div>

                  {
                    loading && <center><Spinner /></center>
                  }


                  <div className="row" style={{ display: loading ? 'none' : 'flex' }}>

                    <div className="col-lg-5 col-md-6 product-single-gallery">
                      <div className="d-flex justify-content-between">
                      </div>
                      {/* {partInfo && <img src={`${gdcURL}/sup-logo/${partInfo[0].SUP_LOGO_NAME}`} style={{ width: '80px' }} />} */}
                      {partInfo?.[0]?.SUP_LOGO_NAME && (
                        <img
                          // src={`${gdcURL}/sup-logo/${partInfo[0].SUP_LOGO_NAME}`}
                          src={`${Config.statement_api}/public/suppliers_logo/${partInfo[0].SUP_LOGO_NAME}`}
                          alt="Supplier Logo"
                          style={{ width: "80px" }}
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      )}

                      {partInfo && <PartImages
                        ART_ID={partInfo[0].ART_ID}
                        SUP_ID={SUP_ID}
                        TITLE={`${partInfo && partInfo[0].ART_SUP_BRAND} ${partInfo && partInfo[0].ART_ARTICLE_NR} ${partInfo && partInfo[0].ART_PRODUCT_NAME}`}
                        PART_NUMBER={ART_NUMBER}
                        setSticky={setSticky}
                        setThumbnail={setThumbnail}
                      />}

                    </div>

                    <div className="col-lg-3 col-md-6 product-single-details">
                      {/* End .price-box */}
                      <div className="product-desc ml-0">
                        <div
                          className="tab-pane fade show active"
                          id="product-desc-content"
                          role="tabpanel"
                          aria-labelledby="product-tab-desc"
                        >

                          {/* <div className="product-desc-content">
                            {
                              partInfo && partInfo[0] &&
                              (() => {
                                const part = partInfo[0];
                                let articleCriteria = [];

                                try {
                                  if (typeof part.ARTICLE_CRITERIA_JSON === "string") {
                                    const firstParse = JSON.parse(part.ARTICLE_CRITERIA_JSON);
                                    articleCriteria = typeof firstParse === "string"
                                      ? JSON.parse(firstParse)
                                      : firstParse;
                                  }
                                } catch (err) {
                                  console.log("ARTICLE_CRITERIA_JSON Parse Error:", err);
                                  try {
                                    articleCriteria = JSON.parse(part.ARTICLE_CRITERIA_JSON);
                                  } catch (e) {
                                    console.log("Fallback parse also failed:", e);
                                    articleCriteria = [];
                                  }
                                }

                                // Ensure articleCriteria is an array
                                if (!Array.isArray(articleCriteria)) {
                                  articleCriteria = [];
                                }

                                const isSpecialPart = ["64193NLHCB", "64210NLHCB", "64211CBNHCB"].includes(part.ART_SEARCH_NUMBER);

                                return (
                                  <div>
                                    <h5 style={{ fontSize: "18px", lineHeight: 0 }}>
                                      {t("specification")}
                                    </h5>

                                    <table
                                      className="table"
                                      dir={dir}
                                      style={{
                                        textAlign: dir === "rtl" ? "right" : "left",
                                        fontSize: "13px",
                                        color: "#333",
                                      }}
                                    >
                                      <tbody>
                                        {articleCriteria
                                          .slice(0, specLimit)
                                          .map((criteria, index) => {
                                            const isQuantity = criteria.criteria_en?.toLowerCase() === "quantity";
                                            const shouldHighlight = isSpecialPart && isQuantity;

                                            return (
                                              <tr key={`info-tr-${index}`}>
                                                <td style={{ padding: "5px" }}>
                                                  <span
                                                    style={{
                                                      color: shouldHighlight ? "red" : "#333",
                                                      fontWeight: shouldHighlight ? "600" : "400",
                                                    }}
                                                  >
                                                    {criteria.criteria_en}
                                                  </span>
                                                </td>
                                                <td style={{ padding: "5px" }}>
                                                  <span
                                                    style={{
                                                      color: shouldHighlight ? "red" : "#333",
                                                      fontWeight: shouldHighlight ? "600" : "400",
                                                    }}
                                                  >
                                                    {criteria.value_en}
                                                  </span>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>

                                    {articleCriteria.length > 10 && (
                                      <center>
                                        <button
                                          onClick={() => setSpecLimit(specLimit > 10 ? 10 : 200)}
                                          className="btn btn-link"
                                        >
                                          {specLimit > 10 ? t("Less") : t("More")}
                                        </button>
                                      </center>
                                    )}
                                  </div>
                                );
                              })()
                            }
                          </div> */}


                          <div className="product-desc-content">
                            {partInfo && partInfo[0] &&
                              (() => {
                                const part = partInfo[0];
                                let articleCriteria = [];

                                try {
                                  if (typeof part.ARTICLE_CRITERIA_JSON === "string") {
                                    const firstParse = JSON.parse(part.ARTICLE_CRITERIA_JSON);

                                    articleCriteria =
                                      typeof firstParse === "string"
                                        ? JSON.parse(firstParse)
                                        : firstParse;
                                  } else if (Array.isArray(part.ARTICLE_CRITERIA_JSON)) {
                                    articleCriteria = part.ARTICLE_CRITERIA_JSON;
                                  }
                                } catch (err) {
                                  console.log("ARTICLE_CRITERIA_JSON Parse Error:", err);
                                  articleCriteria = [];
                                }

                                if (!Array.isArray(articleCriteria)) {
                                  articleCriteria = [];
                                }

                                const isSpecialPart = [
                                  "64193NLHCB",
                                  "64210NLHCB",
                                  "64211CBNHCB",
                                ].includes(part.ART_SEARCH_NUMBER);

                                // Group values by criteria name
                                const groupedCriteria = [];

                                articleCriteria.forEach((criteria) => {
                                  const criteriaName = criteria.criteria_en || "";
                                  const criteriaValue = criteria.value_en ?? "";

                                  const existing = groupedCriteria.find(
                                    (item) =>
                                      item.criteria_en.toLowerCase() ===
                                      criteriaName.toLowerCase()
                                  );

                                  if (existing) {
                                    existing.values.push(criteriaValue);
                                  } else {
                                    groupedCriteria.push({
                                      criteria_en: criteriaName,
                                      values: [criteriaValue],
                                    });
                                  }
                                });

                                const visibleCriteria = groupedCriteria.slice(
                                  0,
                                  specLimit
                                );

                                return (
                                  <div>
                                    <h5
                                      style={{
                                        fontSize: "18px",
                                        marginBottom: "15px",
                                      }}
                                    >
                                      {t("specification")}
                                    </h5>

                                    <table
                                      className="table"
                                      dir={dir}
                                      style={{
                                        width: "100%",
                                        tableLayout: "fixed",
                                        textAlign: dir === "rtl" ? "right" : "left",
                                        fontSize: "13px",
                                        color: "#333",
                                        borderCollapse: "collapse",
                                      }}
                                    >
                                      <tbody>
                                        {visibleCriteria.map((criteria, index) => {
                                          const isQuantity =
                                            criteria.criteria_en.toLowerCase() ===
                                            "quantity";

                                          const shouldHighlight =
                                            isSpecialPart && isQuantity;

                                          return (
                                            <tr key={`info-tr-${index}`}>
                                              <td
                                                style={{
                                                  width: "40%",
                                                  padding: "8px 10px",
                                                  verticalAlign: "top",
                                                  borderBottom: "1px solid #ddd",
                                                  overflowWrap: "anywhere",
                                                  color: shouldHighlight ? "red" : "#333",
                                                  fontWeight: shouldHighlight ? "600" : "400",
                                                }}
                                              >
                                                {criteria.criteria_en}
                                              </td>

                                              <td
                                                style={{
                                                  width: "60%",
                                                  padding: "0 10px",
                                                  verticalAlign: "top",
                                                  borderBottom: "1px solid #ddd",
                                                  overflowWrap: "anywhere",
                                                }}
                                              >
                                                {criteria.values.map((value, valueIndex) => (
                                                  <div
                                                    key={`value-${index}-${valueIndex}`}
                                                    style={{
                                                      padding: "8px 0",
                                                      borderBottom:
                                                        valueIndex < criteria.values.length - 1
                                                          ? "1px solid #ddd"
                                                          : "none",
                                                      color: shouldHighlight ? "red" : "#333",
                                                      fontWeight: shouldHighlight ? "600" : "400",
                                                    }}
                                                  >
                                                    {value}
                                                  </div>
                                                ))}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>

                                    {groupedCriteria.length > 10 && (
                                      <center>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            setSpecLimit(specLimit > 10 ? 10 : 200)
                                          }
                                          className="btn btn-link"
                                        >
                                          {specLimit > 10 ? t("Less") : t("More")}
                                        </button>
                                      </center>
                                    )}
                                  </div>
                                );
                              })()}
                          </div>


                          {/* End .product-desc-content */}
                        </div>
                      </div>
                      {/* End .product-desc */}
                      <ul className="single-info-list ml-2" >
                        <li className="mr-5">
                          {t('part_number')} :
                          <strong>
                            {partInfo && partInfo[0].ART_ARTICLE_NR}
                          </strong>
                        </li>
                        <li>
                          {t('category')}:{" "}
                          <strong>
                            <NavLink to={() => { }} className="product-category">
                              {partInfo && partInfo[0].ART_PRODUCT_NAME}
                            </NavLink>
                          </strong>
                        </li>
                        {car_info && car_info[0] && car_info[0].ART_SUP_BRAND &&
                          <li>

                            {t('brand')}:{" "}
                            <strong>
                              <NavLink to={() => { }} className="product-category">
                                {car_info && car_info[0] && car_info[0].ART_SUP_BRAND && car_info[0].ART_SUP_BRAND}
                              </NavLink>
                            </strong>
                            ,
                          </li>}
                        <li> {t('condition')}:{" "} <strong> <NavLink to={() => { }} className="product-category"> {t('new')} </NavLink> </strong> </li>

                      </ul>

                      {/* End .product-action */}
                      <hr className="divider mb-0 mt-0" />

                      {/* End .product single-share */}
                    </div>


                    <div className='col-lg-4 col-md-6'>
                      <div className="product-action">
                        <div className='row'>


                          {/* ================= PRICE & STOCK ================= */}
                          {!priceLoading && (
                            <div className="col-md-12" style={{}}>

                              {/* ===== OUT OF STOCK ===== */}
                              {isOutOfStock && (
                                <div style={{ color: '#B12704', fontWeight: 600, fontSize: '18px' }}>
                                  <i className="far fa-times-circle"></i> {t('out_of_stock')}
                                </div>
                              )}

                              {/* ===== IN STOCK ===== */}
                              {!isOutOfStock && price > 0 && partInfo && (
                                <>

                                  {/* STOCK STATUS */}
                                  <div style={{ marginBottom: '6px' }}>
                                    <span style={{ color: '#007600' }}>
                                      <i className="far fa-dot-circle"></i>
                                    </span>
                                    <span style={{ marginLeft: '6px', color: '#555' }}>
                                      {t('in_stock')} (Item(s) Left : {partInfo[0]?.stock_available_qty})
                                    </span>
                                  </div>

                                  {/* MRP */}


                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <div>
                                      <span style={{
                                        fontSize: "35px",
                                        fontWeight: 600,
                                        lineHeight: 1
                                      }}>{priceDisplay}</span>
                                    </div>


                                    <div style={{ marginLeft: "10px", marginBottom: "2px", marginTop: "18px" }}>
                                      {
                                        beforePrice > 0 && beforePrice > price &&
                                        <span style={{ color: '#666', fontSize: '16px' }}>
                                          Was:&nbsp;
                                          <del style={{ fontWeight: 500 }}>
                                            {Number(beforePrice).toFixed(2)}{currency.toUpperCase()}
                                          </del>
                                        </span>
                                      }
                                    </div>

                                  </div>


                                  {/* OFFER TEXT */}
                                  <div style={{
                                  }}>
                                    <span style={{ color: '#007600', fontWeight: 600 }}>
                                      Offer price excl. 5% VAT,
                                    </span>
                                    {
                                      (currency || "").toLowerCase() !== "usd" &&

                                      <span style={{ marginLeft: '6px', color: '#B12704', fontWeight: 600 }}>
                                        Free Delivery
                                      </span>
                                    }
                                  </div>

                                </>
                              )}
                            </div>
                          )}

                          {
                            price > 0 && partInfo && partInfo[0] && !isOutOfStock &&
                            <>
                              <div className='col-md-8 mt-1'>
                                {
                                  partInfo &&
                                  ((partInfo[0]?.stock_delivery_days || 0) + (business_delivery_days || 0)) > 0 && (currency || "").toLowerCase() !== "usd" && (
                                    <DeliveryDaysComponent
                                      stock_delivery_days={partInfo[0]?.stock_delivery_days}
                                      business_delivery_days={business_delivery_days}
                                    />
                                  )
                                }
                              </div>
                              <div className="col-md-4"></div>
                            </>

                          }


                          {/* ================= QTY SELECT ================= */}
                          {price > 0 && partInfo && partInfo[0] && !isOutOfStock && (
                            <div className="col-md-4" style={{ marginTop: "10px" }}>
                              <table
                                className='table-bordered'
                                style={{ width: '110px' }}
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      rowSpan={2}
                                      style={{
                                        verticalAlign: 'middle',
                                        textAlign: 'center',
                                        fontWeight: '500',
                                        color: '#132530',
                                        height: '50px'
                                      }}
                                    >
                                      {selectQty}
                                    </td>
                                    <td
                                      style={{ padding: 0, textAlign: 'center', cursor: 'pointer' }}
                                      onClick={() => incrementQty(partInfo[0])}
                                    >
                                      <i className='fas fa-chevron-up'></i>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{ padding: 0, textAlign: 'center', cursor: 'pointer' }}
                                      onClick={() => decrementQty(partInfo[0])}
                                    >
                                      <i className='fas fa-chevron-down'></i>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          )}

                          {/* ================= ADD TO CART ================= */}
                          {
                            price > 0 && partInfo && partInfo[0] && !isOutOfStock &&
                            <div className="col-md-8" style={{ marginTop: "10px" }}>
                              {price > 0 && partInfo && partInfo[0] && (
                                <button
                                  disabled={isOutOfStock}
                                  onClick={() => handleAddToCart(partInfo[0])}
                                  className="btn btn-dark add-cart text-light"
                                  style={{
                                    width: '100%',
                                    opacity: isOutOfStock ? 0.6 : 1,
                                    cursor: isOutOfStock ? 'not-allowed' : 'pointer'
                                  }}
                                >
                                  <i className='fas fa-shopping-cart'></i>
                                  {isOutOfStock ? ` ${t('out_of_stock')}` : ` ${t('add_to_cart')}`}
                                </button>
                              )}
                            </div>
                          }

                          {/* ================= WISHLIST ================= */}
                          {
                            price > 0 && partInfo && partInfo[0] && !isOutOfStock &&
                            <div
                              className="col-md-4 mt-2"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                isFavorite ? handleRemoveToFavorite() : handleAddToFavorite()
                              }
                            >
                              <i
                                className={`isFavorite ${isFavorite ? 'fas' : 'far'} fa-heart favHeart ${isFavorite ? 'active' : ''}`}
                                style={{ fontSize: '18px' }}
                              ></i>
                              <span style={{ fontSize: '14px', fontWeight: 500, marginLeft: '6px' }}>
                                {t('add_to_wishlist')}
                              </span>
                            </div>
                          }


                          {partInfo && partInfo[0]?.SUP_WARRANTY &&
                            <div className='col-md-12 mt-1'>
                              <img
                                src={`/assets/warrenty/${GetWarrantyImage(partInfo[0]?.SUP_WARRANTY)}`}
                                style={{ width: '130px' }}
                                alt='Warranry logo'
                              />
                            </div>
                          }

                          {price > 0 && !isOutOfStock && currency.toLowerCase() !== "usd" &&
                            (
                              <div className="alert alert-danger" style={{ border: "1px dashed #f06548" }}>
                                <div className="d-flex align-items-center">

                                  <lord-icon
                                    src="https://cdn.lordicon.com/nkmsrxys.json"
                                    trigger="loop"
                                    style={{ width: "60px", height: "60px" }}
                                    colors="primary:#cc000b,secondary:#0e1f2a"
                                  />

                                  <div>
                                    <span style={{ color: "#000" }}>
                                      You will get
                                    </span>

                                    <span className="ml-2 mr-2">
                                      <b className='text-primary'>
                                        {UseRewardsPoints(price) ?? 0} rewards points
                                      </b>
                                    </span>

                                    <span style={{ color: "#000" }}>
                                      on this
                                    </span>
                                  </div>

                                </div>
                              </div>
                            )}






                        </div>
                      </div>
                    </div>



                  </div>
                  {/* End .row */}

                </div>

                {partInfo && partInfo[0].PT_NOTE && <div className="container">
                  <div style={{ border: '1px solid #f85a00', borderRadius: '6px', padding: '16px' }}>
                    <svg style={{ marginRight: '2px' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#f85a00" class="bi bi-info-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                    </svg> IMPORTANT <br /><br />{partInfo[0].PT_NOTE}</div><br /><br /></div>}

                {partInfo && <CompatibilityCars ART_ID={partInfo[0].ART_ID} invalidPartMatch={invalidPartMatch} />}
                {partInfo && <OESection ART_ID={partInfo[0].ART_ID} part={partInfo[0]} />}
                {partInfo && <SimilarParts ART_ID={partInfo[0].ART_ID} part={partInfo[0]} />}

                {
                  partInfo &&
                  <NewArrivals />
                }

                {
                  (currency || "").toLowerCase() !== "usd" &&
                  partInfo &&
                  <RedeemOfferSlider />
                }


                <hr style={{ marginTop: 0, marginBottom: '10px' }} />
                <div id="reviews-section">
                  {partInfo && <Reviews title={t('have_you_ever_bought', {
                    value: `${partInfo[0].ART_SUP_BRAND} ${partInfo[0].ART_ARTICLE_NR} ${partInfo[0].ART_PRODUCT_NAME} `
                  })}
                    partNumber={partInfo[0].ART_SEARCH_NUMBER}
                    reviews={reviewsData}
                    supId={partInfo[0]?.ART_SUP_ID}
                  />}
                </div>

                {partInfo && <GetPaymentMethods part={partInfo[0]} />}
                {partInfo && <SimilarCharacteristics ART_ID={partInfo[0].ART_ID} part={partInfo[0]} />}
                {partInfo && <RecentViews />}


              </>
              <br /> <br />
            </div>
          }
        </main >
      }
    </>
  );
}

export default PartDetails;